"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M18.457 13.922A4.541 4.541 0 0 1 23 18.46 4.542 4.542 0 0 1 18.457 23a4.542 4.542 0 0 1-4.544-4.54 4.542 4.542 0 0 1 4.544-4.538Zm.01 1.233a.812.812 0 0 0-.81.812v1.622h-1.622a.812.812 0 0 0 0 1.622h1.622v1.621a.812.812 0 0 0 1.622 0v-1.621H20.9a.812.812 0 0 0 0-1.622h-1.62v-1.622a.812.812 0 0 0-.812-.812Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M11.521 1c5.811 0 10.523 4.71 10.523 10.521 0 .354-.018.704-.052 1.05a1.17 1.17 0 0 1-2.327-.231 8.184 8.184 0 1 0-15.008 3.637 7.718 7.718 0 0 1 10.59-3.665 1.169 1.169 0 1 1-1.08 2.074 5.378 5.378 0 0 0-7.717 3.556 8.146 8.146 0 0 0 5.861 1.726 1.169 1.169 0 0 1 .222 2.327c-.333.032-.67.049-1.011.049C5.71 22.044 1 17.332 1 11.52 1 5.712 5.71 1.002 11.521 1Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M11.521 4.95a2.806 2.806 0 1 1 0 5.611 2.806 2.806 0 0 1 0-5.612Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};